import * as React from 'react';

import * as styles from './OffersStats.css';

export const OffersStats = (props: React.PropsWithChildren): React.JSX.Element => {
  return <div className={styles['offers']}>{props.children}</div>;
};
